const userSubscriptionState = {
    Active: 0,
    Suspended: 1,
    Deactivated: 2
}

export default userSubscriptionState;